import {loadLookupRecord} from '../../../../utils/effectivePermissions';
import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {InputTextarea} from "primereact/inputtextarea";
import moment from 'moment';
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";
import {InputNumber} from "primereact/inputnumber";
import {AutoComplete} from "primereact/autocomplete";
import {useLocation} from "react-router-dom";
import {Checkbox} from "primereact/checkbox";
import {applySchemaProductionDefaults, applyTechnologyDefaultUnit} from "../shared/productionItemDefaults";

const ProjectitemFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [priceCalcLoading, setPriceCalcLoading] = useState({});
  const [schema, setSchema] = useState({});
  const [options, setOptions] = useState({});
  const location = useLocation();
  const [materialDisplay, setMaterialDisplay] = useState({});
  const [materialSuggestions, setMaterialSuggestions] = useState([]);
  const [parentCurrency, setParentCurrency] = useState(null);
  const [formData, setFormData] = useState({
    project: Number(id),
    project_item_schema: Number(window.App.urlVars().projectItemSchemaId),
    project_item: {},
    production_items: [],
    materials: []
  });
  const [newFormData, setNewFormData] = useState({
    production_items: [],
    materials: []
  });
  const [item, setItem] = useState({});
  const [itemOptions, setItemOptions] = useState({});
  const [material, setMaterial] = useState({});
  const [materialCache, setMaterialCache] = useState({});
  const [apiErrors, setApiErrors] = useState({
    project_item: {},
    production_items: {},
    materials: {},
  });
  const [draggedProductionIndex, setDraggedProductionIndex] = useState(null);
  const [productionReorderLoading, setProductionReorderLoading] = useState(false);

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };

  const parseValidationErrors = (error) => {
    const normalizeFieldNames = (fields) => {
      if (!fields || typeof fields !== 'object' || Array.isArray(fields)) {
        return fields || {};
      }

      return Object.entries(fields).reduce((normalized, [fieldName, messages]) => {
        const snakeCaseFieldName = fieldName
          .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
          .toLowerCase();
        normalized[snakeCaseFieldName] = messages;
        return normalized;
      }, {});
    };

    const payload = error?.response?.data || {};
    const root =
      payload?.data?.data ||
      payload?.data ||
      payload?.errors ||
      payload;
    const pi = normalizeFieldNames(root?.project_item || root?.projectItem || {});
    const prod = root?.production_items || root?.productionItems || [];
    const mats = root?.materials || [];
    return {
      project_item: pi,
      production_items: Array.isArray(prod)
      ? prod.map(normalizeFieldNames)
      : prod,
      materials: Array.isArray(mats)
      ? mats.map(normalizeFieldNames)
      : mats,
    };
  };

  const handleValidationError = (error) => {
    const validationErrors = parseValidationErrors(error);
    setApiErrors(validationErrors);

    const firstMessage = [
      ...Object.values(validationErrors.project_item || {}),
      ...Object.values(validationErrors.production_items || {}).flatMap(row => Object.values(row || {})),
      ...Object.values(validationErrors.materials || {}).flatMap(row => Object.values(row || {})),
    ].flat().find(Boolean);

    window.App.toastShow(
      'error',
      t('error'),
      firstMessage || 'Ellenőrizd a hibásan kitöltött mezőket.'
    );
  };

  const onSubmit = (data, form) => {
    setApiErrors({ project_item: {}, production_items: {}, materials: {} });
    setLoading(true);
    if ((window.App.urlVars().projectItemId) || (entity === 'projectItem' && id)) {
      apiCall('put', '/api/v2/project-item/' + (window.App.urlVars().projectItemId ?? id), newFormData)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderProjectitemList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          }
        })
        .catch(error => {
          const status = error?.response?.status;
          if (status === 422 || status === 400) {
            handleValidationError(error);
            return;
          }
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', '/api/v2/project-item', formData)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderProjectitemList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/tmp/tmp/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          const status = error?.response?.status;
          if (status === 422 || status === 400) {
            handleValidationError(error);
            return;
          }
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const getFieldError = (scope, fieldName, rowIndex = null) => {
    if (!apiErrors) return null;
    if (scope === 'project_item') {
      return apiErrors.project_item?.[fieldName]?.[0] || null;
    }
    if (scope === 'production_items') {
      return apiErrors.production_items?.[rowIndex]?.[fieldName]?.[0] || null;
    }
    if (scope === 'materials') {
      return apiErrors.materials?.[rowIndex]?.[fieldName]?.[0] || null;
    }
    return null;
  };

  const clearFieldError = (scope, fieldName, rowIndex = null) => {
    setApiErrors(prev => {
      const next = { ...prev };
      if (scope === 'project_item') {
        const obj = { ...(next.project_item || {}) };
        delete obj[fieldName];
        next.project_item = obj;
        return next;
      }
      const bucket = scope === 'production_items' ? 'production_items' : 'materials';
      const rows = { ...(next[bucket] || {}) };
      const row = { ...(rows[rowIndex] || {}) };
      delete row[fieldName];
      rows[rowIndex] = row;
      next[bucket] = rows;
      return next;
    });
  };

  const getId = (v) => {
    if (v === null || v === undefined) return null;
    if (typeof v === 'object') return v.id ?? null;
    return v;
  };

  const normalizeMaterialToId = (v) => getId(v);

  const ensureMaterialLoaded = async (materialId) => {
    const idNum = Number(materialId);
    if (!idNum || Number.isNaN(idNum)) return null;
    if (materialCache[idNum]) return materialCache[idNum];
    try {
      const r = await loadLookupRecord(apiCall, 'material', idNum, 'ROLE_MATERIAL_READ');
      const obj = r?.data?.data;
      if (obj) setMaterialCache(prev => ({...prev, [idNum]: obj}));
      return obj || null;
    } catch (e) {
      return null;
    }
  };

  const getOptionsForField = (fieldName) => {
    return options?.[fieldName] || itemOptions?.[fieldName] || [];
  };

  const getOptionObject = (fieldName, fieldValue) => {
    const idVal = getId(fieldValue);
    if (!idVal) return null;
    const list = getOptionsForField(fieldName);
    const found = (list || []).find(o => String(o?.id) === String(idVal));
    return found || null;
  };

  const resolvePropertyValue = (fieldName, fieldValue, propertyName) => {
    if (!propertyName) return null;
    if (fieldName === 'material') {
      const mid = normalizeMaterialToId(fieldValue);
      if (!mid) return null;
      const mObj = materialCache[mid];
      if (!mObj) return null;
      return mObj[propertyName];
    }
    if (fieldValue && typeof fieldValue === 'object') {
      return fieldValue[propertyName];
    }

    const optObj = getOptionObject(fieldName, fieldValue);
    if (optObj) return optObj[propertyName];
    return null;
  };

  const normalizeVisibilityDependency = (dep) => {
    if (!dep) return [];
    if (Array.isArray(dep)) {
      if (dep.length === 0) return [];
      if (Array.isArray(dep[0])) return dep;
      return [dep];
    }
    if (typeof dep === 'object') {
      if (dep.materialGeometry && Array.isArray(dep.materialGeometry)) {
        return [[{
          field: 'material',
          property: 'material_geometry',
          values: dep.materialGeometry
        }]];
      }
      return [[dep]];
    }
    return [];
  };

  const isFieldVisibleByDependency = (field, rowData) => {
    const depGroups = normalizeVisibilityDependency(field?.visibilityDependency);
    if (!depGroups || depGroups.length === 0) return true;
    return depGroups.some(andGroup => {
      if (!Array.isArray(andGroup) || andGroup.length === 0) return true;
      return andGroup.every(rule => {
        const depField = rule?.field;
        const depProp = rule?.property;
        const values = rule?.values || [];
        const depValue = rowData ? rowData[depField] : null;
        if (depValue === null || depValue === undefined || depValue === '') return false;
        if (!depProp) return values.includes(depValue);
        const propValue = resolvePropertyValue(depField, depValue, depProp);
        if (propValue === null || propValue === undefined || propValue === '') return false;
        return values.includes(propValue);
      });
    });
  };

  const getVisibleFields = (rowData, fields) => {
    return (fields || []).filter(f => isFieldVisibleByDependency(f, rowData || {}));
  };

  const getEditableVisibleFields = (rowData, fields) => {
    return getVisibleFields(rowData || {}, fields || []).filter(f => f.readonly !== true);
  };

  const isValueFilled = (v) => {
    if (v === null || v === undefined) return false;
    if (typeof v === 'string') return v.trim().length > 0;
    return true;
  };

  const isRowValidForAdd = (rowData, fields) => {
    const visibleFields = getEditableVisibleFields(rowData || {}, fields || []);
    return visibleFields
      .filter(f => f.required === true)
      .every(f => isValueFilled(rowData?.[f.name]));
  };

  const requiredLabel = (field) => (
    <>
      {field.label}
      {field.required === true && <span className="p-error"> *</span>}
    </>
  );

  const buildCleanBacklink = () => {
    const p = new URLSearchParams(location.search || '');
    p.delete('search');
    p.delete('materialId');
    p.delete('materialName');
    p.delete('materialRowIndex');
    p.delete('backlink');
    const qs = p.toString();
    return location.pathname + (qs ? `?${qs}` : '');
  };

  const openMaterialSearch = (rowIndex) => {
    const p = new URLSearchParams(location.search || '');
    p.set('search', 'material');
    p.set('materialRowIndex', String(rowIndex));
    p.set('backlink', buildCleanBacklink());
    history.push(location.pathname + `?${p.toString()}`);
  };

  const searchMaterials = (e) => {
    const qRaw = (e.query || '').trim();
    const q = qRaw.toLowerCase();
    if (!q) {
      setMaterialSuggestions([]);
      return;
    }
    const value = encodeURIComponent(`%${qRaw}%`);
    apiCall(
      'get',
      `/api/v2/material?item_per_page=50&search[name][operator]=like&search[name][value][]=${value}`
    )
      .then(r => {
        const items = r?.data?.data?.items || [];
        const filtered = items.filter(it => String(it?.name || '').toLowerCase().includes(q));
        setMaterialSuggestions(filtered);
      })
      .catch(() => setMaterialSuggestions([]));
  };

  const updateProductionRowField = (rowIndex, fieldName, value) => {
    setFormData(prev => {
      const next = [...(prev.production_items || [])];
      next[rowIndex] = { ...(next[rowIndex] || {}), [fieldName]: value };
      return { ...prev, production_items: next };
    });
    setNewFormData(prev => {
      const next = [...(prev.production_items || [])];
      next[rowIndex] = { ...(next[rowIndex] || {}), [fieldName]: value };
      return { ...prev, production_items: next };
    });
  };

  const normalizeProductionItems = (items) => {
    return (items || []).map((row, index) => ({
      ...row,
      position: index + 1
    }));
  };

  const setProductionItemsState = (items) => {
    const normalized = normalizeProductionItems(items);
    setFormData(prev => ({ ...prev, production_items: normalized }));
    setNewFormData(prev => ({ ...prev, production_items: normalized }));
    return normalized;
  };

  const reorderProductionItems = async (fromIndex, toIndex) => {
    if (fromIndex === toIndex || fromIndex === null || toIndex === null) return;

    const currentItems = [...(formData.production_items || [])];
    if (!currentItems[fromIndex] || !currentItems[toIndex]) return;

    const previousItems = currentItems.map(row => ({ ...row }));
    const [movedItem] = currentItems.splice(fromIndex, 1);
    currentItems.splice(toIndex, 0, movedItem);
    const normalizedItems = setProductionItemsState(currentItems);

    const persistedProjectItemId = window.App.urlVars().projectItemId || (entity === 'projectItem' ? id : null);
    const canPersistOrder = !!persistedProjectItemId && normalizedItems.length > 0 && normalizedItems.every(row => !!row?.id);

    if (!canPersistOrder) {
      return;
    }

    try {
      setProductionReorderLoading(true);
      await apiCall('post', `/api/v2/project-item/${persistedProjectItemId}/production-items/reorder`, {
        production_item_ids: normalizedItems.map(row => Number(row.id))
      });
    } catch (error) {
      setProductionItemsState(previousItems);
      window.App.toastShow('error', t('error'), error.toString(), '', error.response);
    } finally {
      setProductionReorderLoading(false);
    }
  };

  const buildPriceListUrl = ({ currency, technologyId, unitId, now }) => {
    const p = new URLSearchParams();
    p.set('search[currency][operator]', '==');
    p.set('search[currency][value]', currency);

    p.set('search[technology][operator]', '==');
    p.set('search[technology][value]', String(technologyId));

    p.set('search[unit][operator]', '==');
    p.set('search[unit][value]', String(unitId));

    p.set('search[valid_from][operator]', '<=');
    p.set('search[valid_from][value]', now);

    p.set('search[valid_until][operator]', '>=');
    p.set('search[valid_until][value]', now);

    return `/api/v2/price-list-item?${p.toString()}`;
  };

  const applyPriceListCalculator = async (rowIndex) => {
    const isNew = rowIndex === 'new';
    const row = isNew ? (item || {}) : ((formData.production_items || [])[rowIndex] || {});
    const quantity = Number(row.quantity ?? 0);
    const technologyId = row?.technology?.id || row?.technology;
    const unitId = row?.unit?.id || row?.unit;
    const currency = parentCurrency || formData?.currency || null;
    if (!currency) return window.App.toastShow('warn', t('missingData'), t('selectTechnologyWarning'));
    if (!unitId) return window.App.toastShow('warn', t('missingData'), t('selectUnitWarning'));
    if (!quantity || Number.isNaN(quantity)) return window.App.toastShow('warn', 'Hiányzó adat', 'Adj meg mennyiséget.');
    const now = moment().format('YYYY-MM-DD');
    const url = buildPriceListUrl({ currency, technologyId, unitId, now });

    try {
      setPriceCalcLoading(prev => ({ ...prev, [rowIndex]: true }));
      const response = await apiCall('get', url);
      const items = response?.data?.data?.items || response?.data?.data || [];
      const first = Array.isArray(items) ? items[0] : null;
      const price = Number(first?.price);
      if (!first || Number.isNaN(price)) {
        return window.App.toastShow('warn', t('noResults'));
      }
      const netAmount = quantity * price;
      if (isNew) {
        setItem(prev => ({ ...(prev || {}), net_amount: netAmount }));
      } else {
        updateProductionRowField(rowIndex, 'net_amount', netAmount);
        clearFieldError('production_items', 'net_amount', rowIndex);
      }
    } catch (error) {
      window.App.toastShow('error', t('error'), error.toString(), '', error?.response);
    } finally {
      setPriceCalcLoading(prev => ({ ...prev, [rowIndex]: false }));
    }
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  useEffect(() => {
    if ((!window.App.urlVars().create && window.App.urlVars().projectItemId) || (entity === 'projectItem' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/project-item/' + (window.App.urlVars().projectItemId ?? id) + '/schema-edit')
        // .then(response => {
        //   setFormData({
        //     ...response.data.data,
        //     project: Number(id),
        //   })
        //   setNewFormData({
        //     ...response.data.data,
        //     project: Number(id),
        //   })
        // })
        .then(async (response) => {
          const payload = response.data.data;
          const schemaEdit = Array.isArray(payload) ? payload[0] : payload;
          const editItem = schemaEdit?.items?.[0] || {};
          const materialsFixed = (editItem.materials || []).map(mi => {
            const v = mi?.material;
            const mid = normalizeMaterialToId(v);
            if (v && typeof v === 'object' && v.id) {
              setMaterialCache(prev => ({ ...prev, [v.id]: v }));
            }
            return { ...mi, material: mid };
          });
          const uniqueIds = Array.from(
            new Set(
              materialsFixed
                .map(mi => Number(mi?.material))
                .filter(n => n && !Number.isNaN(n))
            )
          );
          await Promise.all(uniqueIds.map(mid => ensureMaterialLoaded(mid)));
          const productionItemsFixed = [...(editItem.production_items || [])].sort((a, b) => {
            const aPosition = Number(a?.position ?? Number.MAX_SAFE_INTEGER);
            const bPosition = Number(b?.position ?? Number.MAX_SAFE_INTEGER);
            if (aPosition !== bPosition) return aPosition - bPosition;
            return Number(a?.id || 0) - Number(b?.id || 0);
          });
          const fixedData = {
            project: Number(schemaEdit?.project?.id || id),
            project_item_schema: schemaEdit?.schema?.id || Number(window.App.urlVars().projectItemSchemaId),
            project_item: editItem.projectItem || {},
            production_items: productionItemsFixed,
            materials: materialsFixed
          };
          setFormData(fixedData);
          setNewFormData(fixedData);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
    if (window.App.urlVars().projectItemSchemaId) {
      apiCall('get', '/api/v2/project-item-schema/' + window.App.urlVars().projectItemSchemaId)
        .then(response => {
          setSchema(response.data)
          const isUpdate = window.App.urlVars().projectItemId || (entity === 'projectItem' && id);
          if (!isUpdate) {
            const defaults = response?.data?.productionItems?.defaults || [];
            setFormData(prev => applySchemaProductionDefaults(prev, defaults));
            setNewFormData(prev => applySchemaProductionDefaults(prev, defaults));
          }
          response?.data?.projectItem?.form?.fields?.map((field, index) => {
            if (field.type === 'select') {
              setLoading(true)
              apiCall('get', field?.options?.endpoint)
                .then(response => {
                  setOptions((prev) => ({...prev, [field.name]: response.data.data.items}))
                })
                .catch(error => {
                  window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                })
            }
          })
          response?.data?.productionItems?.itemForm?.fields?.map((field, index) => {
            if (field.type === 'select') {
              apiCall('get', field?.options?.endpoint)
                .then(response => {
                  setItemOptions((prev) => ({...prev, [field.name]: response.data.data.items}))
                })
                .catch(error => {
                  window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                })
            }
          })
          // response?.data?.materials?.itemForm?.fields?.forEach((field) => {
          //   if (field.type === 'select') {
          //     const endpoint = field?.options?.endpoint || '';
          //     apiCall('get', endpoint)
          //       .then(r => {
          //         const items = r?.data?.data?.items || [];
          //         setMaterialOptions((prev) => ({...prev, [field.name]: items}))
          //       })
          //       .catch(error => {
          //         window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          //       })
          //   }
          // })
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }, [])

  useEffect(() => {
    const isUpdate =
      window.App.urlVars().projectItemId ||
      (entity === 'projectItem' && id);
    if (isUpdate) return;
    apiCall('get', '/api/v2/network/settings')
      .then(response => {
        const settings = response?.data?.data || {};
        const defaultUnit = getId(settings?.default_unit);
        const defaultVatRate = getId(settings?.default_vat_rate);
        setFormData(prev => ({
          ...prev,
          project_item: {
            ...(prev.project_item || {}),
            ...(defaultUnit ? { unit: defaultUnit } : {}),
            ...(defaultVatRate ? { vat_rate: defaultVatRate } : {})
          }
        }));
        setNewFormData(prev => ({
          ...prev,
          project_item: {
            ...(prev.project_item || {}),
            ...(defaultUnit ? { unit: defaultUnit } : {}),
            ...(defaultVatRate ? { vat_rate: defaultVatRate } : {})
          }
        }));
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
  }, []);

  useEffect(() => {
    if (!id || id === 'undefined') return;
    apiCall('get', '/api/v2/project/' + id)
      .then(response => {
        setParentCurrency(response?.data?.data?.currency || null);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
  }, [id]);

  useEffect(() => {
    const vars = window.App.urlVars();
    if (!vars?.materialId || vars?.materialRowIndex === undefined || vars?.materialRowIndex === null) return;
    const materialId = Number(vars.materialId);
    const materialName = decodeURIComponent(String(vars.materialName || '').replace(/\+/g, ' '));
    const rowIndexRaw = String(vars.materialRowIndex);
    if (rowIndexRaw === 'new') {
      (async () => {
        setMaterialDisplay(prev => ({...prev, new: materialName}));
        await ensureMaterialLoaded(materialId);
        setMaterial(prev => ({...prev, material: materialId}));
      })();
      return;
    }
    const rowIndex = Number(rowIndexRaw);
    if (Number.isNaN(rowIndex)) return;
    (async () => {
      await ensureMaterialLoaded(materialId);
      setMaterialDisplay(prev => ({...prev, [rowIndex]: materialName}));
      setFormData(prev => {
        const materials = [...(prev.materials || [])];
        materials[rowIndex] = {...(materials[rowIndex] || {}), material: materialId};
        return {...prev, materials};
      });
      setNewFormData(prev => {
        const materials = [...(prev.materials || [])];
        materials[rowIndex] = {...(materials[rowIndex] || {}), material: materialId};
        return {...prev, materials};
      });
    })();
  }, [location.search, schema]);

  return (
    <div className={"tmp-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <div className={"p-grid"}>
        <div className={"p-col-12 p-lg-6 p-xl-6"}>
          <h3 className={"p-m-0 p-p-0"}>
            {schema?.projectItem?.form?.title || 'Alap adatok'}
          </h3>
        </div>
        <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>

        </div>
      </div>
      {loading === false &&
        <Form onSubmit={onSubmit} initialValues={formData}
              validate={validate} render={({handleSubmit, submitting}) => (
          <form onSubmit={handleSubmit} className="">
            <div className={"p-grid"}>
              {schema?.projectItem?.form?.fields?.map((field, index) => {
                const rowData = formData?.project_item || {};
                const visible = isFieldVisibleByDependency(field, rowData);
                if (!visible || field.readonly === true) return null;
                if (field.type === 'string') {
                  return (
                    <div className={"p-col-12 p-lg-6"} key={field.name}>
                      <Field name={field.name} render={({input, meta}) => (
                        <div className="p-field p-fluid">
                          <label
                            htmlFor={field.name}
                            className={classNames({
                              'p-error': !!getFieldError('project_item', field.name)
                            })}
                          >
                            {requiredLabel(field)}
                          </label>
                          <span className="p-d-block">
                        {field.widget === 'textarea' ? <InputTextarea id={field.name} {...input}
                                   rows={4}
                                   autoResize
                                   onChange={(e) => {
                                     const nextProjectItem = {
                                      ...(formData.project_item || {}),
                                      [field.name]: e.target.value
                                    };

                                     setFormData({
                                       ...formData,
                                       project_item: nextProjectItem
                                     })
                                     setNewFormData({
                                       ...newFormData,
                                       project_item: nextProjectItem
                                     })
                                     clearFieldError('project_item', field.name);
                                   }}
                                   value={formData?.project_item?.[field.name] || ''}
                                   placeholder={field.placeholder}
                                   className={classNames({
                                    'p-invalid': !!getFieldError('project_item', field.name)
                                  })}/> : <InputText id={field.name} {...input}
                                   onChange={(e) => {
                                     const nextProjectItem = {
                                      ...(formData.project_item || {}),
                                      [field.name]: e.target.value
                                    };
                                     setFormData({...formData, project_item: nextProjectItem});
                                     setNewFormData({...newFormData, project_item: nextProjectItem});
                                     clearFieldError('project_item', field.name);
                                   }}
                                   value={formData?.project_item?.[field.name] || ''}
                                   placeholder={field.placeholder}
                                   className={classNames({
                                     'p-invalid': !!getFieldError('project_item', field.name)
                                   })}/>
                        }
                        </span>
                          {/* {getFormErrorMessage(meta)} */}
                          {getFieldError('project_item', field.name) && (
                            <small className="p-error">
                              {getFieldError('project_item', field.name)}
                            </small>
                          )}
                        </div>
                      )}/>
                    </div>
                  )
                }
                if (field.type === 'bool') {
                  return (
                    <div className={"p-col-12 p-lg-6"} key={field.name}>
                      <Field name={field.name} render={({input, meta}) => (
                        <div className="p-field">
                          <label
                            htmlFor={field.name}
                            className={classNames({
                              'p-error': !!getFieldError('project_item', field.name)
                            })}
                          >
                            {requiredLabel(field)}
                          </label>
                          <div className="p-d-flex p-ai-center p-mt-2">
                            <Checkbox
                              inputId={field.name}
                              checked={!!formData?.project_item?.[field.name]}
                              onChange={(e) => {
                                const nextProjectItem = {
                                  ...(formData.project_item || {}),
                                  [field.name]: e.checked
                                };
                                setFormData({
                                  ...formData,
                                  project_item: nextProjectItem
                                });
                                setNewFormData({
                                  ...newFormData,
                                  project_item: nextProjectItem
                                });
                                clearFieldError('project_item', field.name);
                              }}
                              className={classNames({
                                'p-invalid': !!getFieldError('project_item', field.name)
                              })}
                            />
                            <label htmlFor={field.name} className="p-ml-2 p-mb-0">
                              {field.placeholder || field.label}
                            </label>
                          </div>
                          {getFieldError('project_item', field.name) && (
                            <small className="p-error">
                              {getFieldError('project_item', field.name)}
                            </small>
                          )}
                        </div>
                      )}/>
                    </div>
                  );
                }
                if (field.type === 'number') {
                  return (
                    <div className={"p-col-12 p-lg-6"}>
                      <Field name={field.name} render={({input, meta}) => (
                        <div className="p-field p-fluid">
                          <label
                            htmlFor={field.name}
                            className={classNames({
                              'p-error': !!getFieldError('project_item', field.name)
                            })}
                          >
                           {requiredLabel(field)} 
                          </label>
                          <span className="p-d-block">
                        <InputNumber id={field.name} {...input}
                                     minFractionDigits={0}
                                     maxFractionDigits={2}
                                     mode='decimal'
                                     onChange={(e) => {
                                       const nextProjectItem = {
                                          ...(formData.project_item || {}),
                                          [field.name]: e.value
                                        };
                                       setFormData({
                                         ...formData,
                                         project_item: nextProjectItem
                                       })
                                       setNewFormData({
                                         ...newFormData,
                                         project_item: nextProjectItem
                                       })
                                       clearFieldError('project_item', field.name);
                                     }}
                                      value={formData?.project_item?.[field.name] ?? null}
                                     placeholder={field.placeholder}
                                     className={classNames({
                                      'p-invalid': !!getFieldError('project_item', field.name)
                                    })}/>
                        </span>
                          {/* {getFormErrorMessage(meta)} */}
                          {getFieldError('project_item', field.name) && (
                            <small className="p-error">
                              {getFieldError('project_item', field.name)}
                            </small>
                          )}
                        </div>
                      )}/>
                    </div>
                  )
                }
                if (field.type === 'select') {
                  return (
                    <div className={"p-col-12 p-lg-6"}>
                      <Field name={field.name} render={({input, meta}) => (
                        <div className="p-field p-fluid">
                          <label
                            htmlFor={field.name}
                            className={classNames({
                              'p-error': !!getFieldError('project_item', field.name)
                            })}
                          >
                            {requiredLabel(field)}
                          </label>
                          <span className="p-d-block">
                        <Dropdown {...input}
                                  onChange={(e) => {
                                    const nextProjectItem = {
                                      ...(formData.project_item || {}),
                                      [field.name]: e.value
                                    };
                                    setFormData({
                                      ...formData,
                                      project_item: nextProjectItem
                                    })
                                    setNewFormData({
                                      ...newFormData,
                                      project_item: nextProjectItem
                                    })
                                    clearFieldError('project_item', field.name);
                                  }}
                                  value={
                                    formData?.project_item?.[field.name]?.id ||
                                    formData?.project_item?.[field.name] ||
                                    null
                                  }
                                  options={window.App.sortDropdownOptions(
                                    options[field.name] || [],
                                    field?.options?.labelField || "name"
                                  )}
                                  optionLabel={field?.options?.labelField || "name"}
                                  optionValue="id"
                                  id={field.name}
                                  emptyMessage={t('noSelectableItemYet')}
                                  className={classNames({
                                    'p-invalid': !!getFieldError('project_item', field.name)
                                  })}
                        />
                        </span>
                          {/* {getFormErrorMessage(meta)} */}
                          {getFieldError('project_item', field.name) && (
                            <small className="p-error">
                              {getFieldError('project_item', field.name)}
                            </small>
                          )}
                        </div>
                      )}/>
                    </div>
                  )
                }
              })}
            </div>
            {schema?.productionItems?.enabled === true && (
              <>
                <div className={"p-grid p-mt-1"}>
                  <div className={"p-col-12 p-lg-6 p-xl-6"}>
                    <h3 className={"p-m-0 p-p-0"}>
                      {schema?.productionItems?.itemForm?.title || t('items')}
                    </h3>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>

                  </div>
                </div>

                <div style={{ overflowX: 'auto' }}>
                  <table className={"p-mt-0 w-100"} cellPadding={'5px'} cellSpacing={0}>
                    <tr>
                      <th style={{width: '40px'}}></th>
                      {getEditableVisibleFields(item || {}, schema?.productionItems?.itemForm?.fields)?.map((field, index) => {
                        return (
                          <th key={field.name || index}>
                            {requiredLabel(field)}
                          </th>
                        )
                      })}
                      <th></th>
                    </tr>

                    {formData.production_items && formData.production_items[0] ? (
                      <>
                        {formData.production_items.map((item, indexItem) => {
                          return (
                            <tr
                              key={item.id || indexItem}
                              onDragOver={(e) => {
                                if (draggedProductionIndex === null || draggedProductionIndex === indexItem) return;
                                e.preventDefault();
                              }}
                              onDrop={(e) => {
                                e.preventDefault();
                                if (draggedProductionIndex === null) return;
                                reorderProductionItems(draggedProductionIndex, indexItem);
                                setDraggedProductionIndex(null);
                              }}
                              style={{
                                opacity: draggedProductionIndex === indexItem ? 0.55 : 1
                              }}
                            >
                              <td className="p-text-center" style={{width: '40px'}}>
                                <span
                                  draggable={!productionReorderLoading}
                                  onDragStart={() => setDraggedProductionIndex(indexItem)}
                                  onDragEnd={() => setDraggedProductionIndex(null)}
                                  style={{
                                    cursor: productionReorderLoading ? 'not-allowed' : 'grab',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '24px',
                                    height: '24px',
                                    opacity: productionReorderLoading ? 0.45 : 1
                                  }}
                                  title={t('reorderRows') || 'Sorrend módosítása'}
                                >
                                  <i className="pi pi-bars"></i>
                                </span>
                              </td>
                              {schema?.productionItems?.itemForm?.fields?.map((_field, index) => {
                                if (_field.readonly === true) return null;
                                const rowData = formData.production_items[indexItem] || {};
                                const visible = isFieldVisibleByDependency(_field, rowData);
                                if (!visible) return (<td key={_field.name || index}></td>);

                                if (_field?.type === 'bool') return (
                                  <td key={_field.name || index} className="p-text-center">
                                    {(() => {
                                      const err = getFieldError('production_items', _field.name, indexItem);
                                      return (
                                        <>
                                          <Checkbox
                                            checked={!!formData.production_items[indexItem][_field.name]}
                                            onChange={(e) => {
                                              const production_items = [...formData.production_items];
                                              production_items[indexItem] = {
                                                ...production_items[indexItem],
                                                [_field.name]: e.checked
                                              };
                                              setFormData({
                                                ...formData,
                                                production_items
                                              });
                                              setNewFormData({
                                                ...newFormData,
                                                production_items
                                              });
                                              if (err) clearFieldError('production_items', _field.name, indexItem);
                                            }}
                                            className={classNames({
                                              'p-invalid': !!err
                                            })}
                                          />
                                          {err && (
                                            <small className="p-error p-d-block">
                                              {err}
                                            </small>
                                          )}
                                        </>
                                      );
                                    })()}
                                  </td>
                                );

                                if (_field?.type === 'number') {
                                  const hasPriceListCalc = _field.name === 'net_amount' && Array.isArray(_field.extras) && _field.extras.includes('priceListCalculator');
                                  const err = getFieldError('production_items', _field.name, indexItem);
                                  return (
                                    <td key={_field.name || index}>
                                      <div className={hasPriceListCalc ? "p-inputgroup" : ""}>
                                        <InputNumber
                                          onChange={(e) => {
                                            const production_items = [...formData.production_items];
                                            production_items[indexItem] = {
                                              ...production_items[indexItem],
                                              [_field.name]: e.value
                                            };
                                            setFormData({...formData, production_items});
                                            setNewFormData({...newFormData, production_items});
                                            if (err) clearFieldError('production_items', _field.name, indexItem);
                                          }}
                                          minFractionDigits={0}
                                          maxFractionDigits={2}
                                          mode='decimal'
                                          className={"w-100"}
                                          value={formData.production_items[indexItem][_field.name]}
                                          placeholder={_field.placeholder}
                                        />

                                        {hasPriceListCalc && (
                                          <Button
                                            type="button"
                                            icon={priceCalcLoading[indexItem] ? "pi pi-spin pi-spinner" : "pi pi-dollar"}
                                            disabled={!!priceCalcLoading[indexItem]}
                                            className="p-button-secondary"
                                            onClick={() => applyPriceListCalculator(indexItem)}
                                            tooltip={t('priceListCalculator')}
                                            tooltipOptions={{ position: 'top' }}
                                          />
                                        )}
                                      </div>
                                      {err && <small className="p-error">{err}</small>}
                                    </td>
                                  );
                                }

                                if (_field?.type === 'select') return (
                                  <td key={_field.name || index}>
                                    {(() => {
                                      const err = getFieldError('production_items', _field.name, indexItem);
                                      return (
                                        <Dropdown
                                          onChange={(e) => {
                                            const production_items = [...formData.production_items];
                                            production_items[indexItem] = applyTechnologyDefaultUnit(
                                              production_items[indexItem],
                                              _field.name,
                                              e.value,
                                              itemOptions.technology || []
                                            )
                                            setFormData({
                                              ...formData,
                                              production_items: production_items
                                            })
                                            setNewFormData({
                                              ...newFormData,
                                              production_items: production_items
                                            })
                                            if (err) clearFieldError('production_items', _field.name, indexItem);
                                          }}
                                          value={formData.production_items[indexItem][_field.name]}
                                          options={window.App.sortDropdownOptions(
                                            itemOptions[_field.name] || [],
                                            _field?.options?.labelField || "name"
                                          )}
                                          optionLabel={_field?.options?.labelField || "name"}
                                          optionValue="id"
                                          className={classNames("w-100", { 'p-invalid': !!err })}
                                          emptyMessage={t('noSelectableItemYet')}
                                        />
                                      );
                                    })()}
                                    {getFieldError('production_items', _field.name, indexItem) && (
                                      <small className="p-error">{getFieldError('production_items', _field.name, indexItem)}</small>
                                    )}
                                  </td>
                                )

                                if (_field?.type === 'string') return (
                                  <td key={_field.name || index}>
                                    <InputText
                                      onChange={(e) => {
                                        const production_items = [...formData.production_items];
                                        production_items[indexItem] = {...production_items[indexItem], [_field.name]: e.target.value}
                                        setFormData({
                                          ...formData,
                                          production_items: production_items
                                        })
                                        setNewFormData({
                                          ...newFormData,
                                          production_items: production_items
                                        })
                                      }}
                                      className={"w-100"}
                                      value={formData.production_items[indexItem][_field.name]}
                                      placeholder={_field.placeholder}
                                    />
                                  </td>
                                )

                                return <td key={_field.name || index}></td>;
                              })}

                              <td className={"p-text-right"}>
                                <Button
                                  type="button"
                                  onClick={() => {
                                    const updatedProductionItems = [...(formData.production_items || [])];
                                    updatedProductionItems.splice(indexItem, 1);
                                    setProductionItemsState(updatedProductionItems);
                                  }}
                                  icon={"pi pi-trash"}
                                  className="p-button-danger"
                                />
                              </td>
                            </tr>
                          )
                        })}
                      </>
                    ) : (
                      <tr>
                        <td colSpan={(schema?.productionItems?.itemForm?.fields?.length || 1) + 2} className={"p-text-center"}>
                          Még nincs tétel. Adj hozzá új tételt!
                        </td>
                      </tr>
                    )}

                    <tfoot className={"add"}>
                      <tr className={"add-spacer"}>
                        <td></td>
                        {getEditableVisibleFields(item || {}, schema?.productionItems?.itemForm?.fields)?.map((field, index) => {
                          const rowData = item || {};
                          const visible = isFieldVisibleByDependency(field, rowData);
                          if (!visible) return (<td key={field.name || index}></td>);
                          return (
                            <td key={field.name || index}>
                              <i className={"pi pi-arrow-up"}></i>
                            </td>
                          )
                        })}
                        <td></td>
                      </tr>

                      <tr className={"add-form"}>
                        <td></td>
                        {getEditableVisibleFields(item || {}, schema?.productionItems?.itemForm?.fields)?.map((field, index) => {
                          const rowData = item || {};
                          const visible = isFieldVisibleByDependency(field, rowData);
                          if (!visible) return (<td key={field.name || index}></td>);

                          if (field.type === 'number') {
                            const hasPriceListCalc = field.name === 'net_amount' && Array.isArray(field.extras) && field.extras.includes('priceListCalculator');
                            return (
                              <td key={field.name || index}>
                                <div className={hasPriceListCalc ? "p-inputgroup" : ""}>
                                  <InputNumber
                                    id={field.name}
                                    minFractionDigits={0}
                                    maxFractionDigits={2}
                                    mode='decimal'
                                    onChange={(e) => {
                                      setItem({
                                        ...item,
                                        [field.name]: (e.value === null || e.value === undefined) ? null : Number(e.value)
                                      });
                                    }}
                                    className={"w-100"}
                                    value={item[field.name]}
                                    placeholder={field.placeholder}
                                  />
                                  {hasPriceListCalc && (
                                    <Button
                                      type="button"
                                      icon={priceCalcLoading['new'] ? "pi pi-spin pi-spinner" : "pi pi-dollar"}
                                      disabled={!!priceCalcLoading['new']}
                                      className="p-button-secondary"
                                      onClick={() => applyPriceListCalculator('new')}
                                      tooltip={t('priceListCalculator')}
                                      tooltipOptions={{ position: 'top' }}
                                    />
                                  )}
                                </div>
                              </td>
                            );
                          }

                          if (field.type === 'bool') return (
                            <td key={field.name || index} className="p-text-center">
                              <Checkbox
                                id={field.name}
                                checked={!!item[field.name]}
                                onChange={(e) => {
                                  setItem({
                                    ...item,
                                    [field.name]: e.checked
                                  });
                                }}
                              />
                            </td>
                          );

                          if (field.type === 'string') return (
                            <td key={field.name || index}>
                              <InputText
                                id={field.name}
                                onChange={(e) => {
                                  setItem({...item, [field.name]: e.target.value})
                                }}
                                className={"w-100"}
                                value={item[field.name]}
                                placeholder={field.placeholder}
                              />
                            </td>
                          )

                          if (field.type === 'select') return (
                            <td key={field.name || index}>
                              <Dropdown
                                onChange={(e) => {
                                  setItem(applyTechnologyDefaultUnit(
                                    item,
                                    field.name,
                                    e.target.value,
                                    itemOptions.technology || []
                                  ))
                                }}
                                value={item[field.name]?.id || item[field.name]}
                                options={window.App.sortDropdownOptions(
                                  itemOptions[field.name] || [],
                                  field?.options?.labelField || "name"
                                )}
                                optionLabel={field?.options?.labelField || "name"}
                                optionValue="id"
                                id={field.name}
                                className={"w-100"}
                                emptyMessage={t('noSelectableItemYet')}
                              />
                            </td>
                          )

                          return <td key={field.name || index}></td>;
                        })}

                        <td className={"p-text-right"}>
                          <Button
                            type="button"
                            disabled={!isRowValidForAdd(item, schema?.productionItems?.itemForm?.fields)}
                            onClick={() => {
                              setProductionItemsState([...(formData.production_items || []), item])
                              setItem({})
                            }}
                            icon={"pi pi-plus"}
                            className="p-button-success"
                          />
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </>
            )}
            {schema?.materials?.itemForm &&
              <>
                <div className={"p-grid p-mt-1"}>
                  <div className={"p-col-12 p-lg-6 p-xl-6"}>
                    <h3 className={"p-m-0 p-p-0"}>
                      {schema?.materials?.itemForm?.title || 'Anyagok'}
                    </h3>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>

                  </div>
                </div>
                <div style={{overflowX: 'auto'}}>
                  <table className={"p-mt-0 w-100"} cellPadding={'5px'} cellSpacing={0} style={{minWidth: '900px'}}>
                  <tr>
                    {getEditableVisibleFields(material || {}, schema?.materials?.itemForm?.fields)?.map((field, index) => {
                      return (
                        <th key={field.name || index}>
                          {requiredLabel(field)}
                        </th>
                      )
                    })}
                    <th></th>
                  </tr>
                  {formData.materials && formData.materials[0] ? (
                    <>
                      {formData.materials.map((item, indexItem) => {
                        return (
                          <tr key={indexItem}>
                            {schema?.materials?.itemForm?.fields?.map((_field, index) => {
                              if (_field.readonly === true) return null;
                              const rowData = formData.materials[indexItem] || {};
                              const visible = isFieldVisibleByDependency(_field, rowData);
                              if (!visible) return (<td key={_field.name || index}></td>);
                              if (_field?.type === 'bool') return (
                                <td key={_field.name || index} className="p-text-center">
                                  {(() => {
                                    const err = getFieldError('materials', _field.name, indexItem);
                                    return (
                                      <>
                                        <Checkbox
                                          checked={!!formData.materials[indexItem][_field.name]}
                                          onChange={(e) => {
                                            const materials = [...formData.materials];
                                            materials[indexItem] = {
                                              ...materials[indexItem],
                                              [_field.name]: e.checked
                                            };
                                            setFormData({
                                              ...formData,
                                              materials
                                            });
                                            setNewFormData({
                                              ...newFormData,
                                              materials
                                            });
                                            if (err) clearFieldError('materials', _field.name, indexItem);
                                          }}
                                          className={classNames({
                                            'p-invalid': !!err
                                          })}
                                        />
                                        {err && (
                                          <small className="p-error p-d-block">
                                            {err}
                                          </small>
                                        )}
                                      </>
                                    );
                                  })()}
                                </td>
                              );
                              if (_field?.type === 'number') return (
                                <td key={_field.name || index}>
                                  {(() => {
                                  const err = getFieldError('materials', _field.name, indexItem);
                                  return (
                                  <InputNumber onChange={(e) => {
                                    const materials = [...formData.materials];
                                    materials[indexItem] = {
                                      ...materials[indexItem],
                                      [_field.name]: (e.value === null || e.value === undefined || e.value === '') ? null : e.value
                                    };
                                    setFormData({...formData, materials})
                                    setNewFormData({...newFormData, materials})
                                    if (err) clearFieldError('materials', _field.name, indexItem);
                                  }}
                                    mode="decimal"
                                    minFractionDigits={0}
                                    maxFractionDigits={2}
                                    className={classNames("w-100", { 'p-invalid': !!err })}
                                    value={formData.materials[indexItem][_field.name]}
                                    placeholder={_field.placeholder}
                                  />
                                  );
                                  })()}
                                  {getFieldError('materials', _field.name, indexItem) && (
                                    <small className="p-error">{getFieldError('materials', _field.name, indexItem)}</small>
                                  )}
                                </td>
                              )
                              if (_field?.type === 'select' && _field.name === 'material') return (
                                <td key={_field.name || index}>
                                  <div className="p-inputgroup">
                                    <Button type="button" icon="pi pi-search"
                                      className="p-button-primary"
                                      onClick={() => openMaterialSearch(indexItem)}
                                    />
                                    <AutoComplete
                                      value={materialDisplay[indexItem] || ''}
                                      suggestions={materialSuggestions}
                                      completeMethod={searchMaterials}
                                      field="name"
                                      appendTo={document.body}
                                      panelClassName="material-ac-panel"
                                      dropdownMode="current"
                                      minLength={1}
                                      delay={250}
                                      placeholder={t('materialSearchPlaceholder')}className="w-100"
                                      onChange={(e) => {
                                        setMaterialDisplay(prev => ({...prev, [indexItem]: e.value}));
                                        if (!e.value) {
                                          const materials = [...formData.materials];
                                          materials[indexItem] = {...materials[indexItem], material: null};
                                          setFormData({...formData, materials});
                                          setNewFormData({...newFormData, materials});
                                        }
                                      }}
                                      onSelect={async (e) => {
                                        const picked = e.value;
                                        setMaterialDisplay(prev => ({...prev, [indexItem]: picked.name}));
                                        await ensureMaterialLoaded(picked.id);
                                        const materials = [...formData.materials];
                                        const nextRow = {...(materials[indexItem]||{}), material: picked.id}
                                        materials[indexItem] = nextRow;
                                        setFormData({...formData, materials});
                                        setNewFormData({...newFormData, materials});
                                      }}
                                    />
                                  </div>
                                </td>
                              )
                              if (_field?.type === 'string') return (
                                <td key={_field.name || index}>
                                  <InputText onChange={(e) => {
                                    const materials = [...formData.materials];
                                    materials[indexItem] = {
                                      ...materials[indexItem],
                                      [_field.name]: e.target.value
                                    };
                                    setFormData({
                                      ...formData,
                                      materials: materials
                                    })
                                    setNewFormData({
                                      ...newFormData,
                                      materials: materials
                                    })
                                  }}
                                             className={"w-100"}
                                             value={formData.materials[indexItem][_field.name]}
                                             placeholder={_field.placeholder}
                                  />
                                </td>
                              )
                            })}
                            <td className={"p-text-right"}>
                              <Button type="button"
                                      onClick={() => {
                                        setFormData((prevState) => {
                                          const updatedMaterials = [...prevState.materials];
                                          updatedMaterials.splice(indexItem, 1);
                                          return {...prevState, materials: updatedMaterials};
                                        });
                                        setNewFormData((prevState) => {
                                          const updatedMaterials = [...prevState.materials];
                                          updatedMaterials.splice(indexItem, 1);
                                          return {...prevState, materials: updatedMaterials};
                                        });
                                      }}
                                      icon={"pi pi-trash"}
                                      className="p-button-danger"/>
                            </td>
                          </tr>
                        )
                      })}
                    </>
                  ) : (
                    <tr>
                      <td colSpan={schema?.materials?.itemForm?.fields.length} className={"p-text-center"}>
                        Még nincs tétel. Adj hozzá új tételt!
                      </td>
                      <td></td>
                    </tr>
                  )}
                  <tfoot className={"add"}>
                  <tr className={"add-spacer"}>
                    {getEditableVisibleFields(material || {}, schema?.materials?.itemForm?.fields)?.map((field, index) => {
                      const rowData = material || {};
                      const visible = isFieldVisibleByDependency(field, rowData);
                      if (!visible) return (<td key={field.name || index}></td>);
                      return (
                        <td key={field.name || index}>
                          <i className={"pi pi-arrow-up"}></i>
                        </td>
                      )
                    })}
                    <td></td>
                  </tr>
                  <tr className={"add-form"}>
                    {getEditableVisibleFields(material || {}, schema?.materials?.itemForm?.fields)?.map((field, index) => {
                      const rowData = material || {};
                      const visible = isFieldVisibleByDependency(field, rowData);
                      if (!visible) return (<td key={field.name || index}></td>);
                      if (field.type === 'bool') return (
                        <td key={field.name || index} className="p-text-center">
                          <Checkbox
                            inputId={field.name}
                            checked={!!material[field.name]}
                            onChange={(e) => {
                              setMaterial(prev => ({
                                ...prev,
                                [field.name]: e.checked
                              }));
                            }}
                          />
                        </td>
                      );
                      if (field.type === 'number') return (
                        <td key={field.name || index}>
                          <InputNumber
                            id={field.name}
                            onChange={(e) => {
                              setMaterial(prev => ({
                                ...prev,
                                [field.name]: (e.value === null || e.value === undefined || e.value === '') ? null : e.value
                              }));
                            }}
                            mode="decimal"
                            minFractionDigits={0}
                            maxFractionDigits={2}
                            className={"w-100"}
                            value={material[field.name]}
                            placeholder={field.placeholder}
                          />
                        </td>
                      );
                      if (field.type === 'string') return (
                        <td key={field.name || index}>
                          <InputText
                            id={field.name}
                            onChange={(e) => {
                              setMaterial(prev => ({...prev, [field.name]: e.target.value}));
                            }}
                            className={"w-100"}
                            value={material[field.name]}
                            placeholder={field.placeholder}
                          />
                        </td>
                      );
                      if (field.type === 'select' && field.name === 'material') return (
                        <td key={field.name || index}>
                          <div className="p-inputgroup">
                            <Button
                              type="button"
                              icon="pi pi-search"
                              className="p-button-primary"
                              onClick={() => openMaterialSearch('new')}
                            />
                            <AutoComplete
                              value={materialDisplay['new'] || ''}
                              suggestions={materialSuggestions}
                              completeMethod={searchMaterials}
                              field="name"
                              onChange={(e) => {
                                setMaterialDisplay(prev => ({...prev, ['new']: e.value}));
                                if (!e.value) {
                                  setMaterial(prev => ({...prev, material: null}));
                                }
                              }}
                              onSelect={async (e) => {
                                const picked = e.value;
                                setMaterialDisplay(prev => ({...prev, ['new']: picked.name}));
                                await ensureMaterialLoaded(picked.id);
                                setMaterial(prev => ({...prev, material: picked.id}));
                                ensureMaterialLoaded(picked.id);
                              }}
                              placeholder={t('materialTypeToSearchPlaceholder')}className="w-100"
                            />
                          </div>
                        </td>
                      );
                      return (<td key={field.name || index}></td>);
                    })}
                    <td className={"p-text-right"}>
                      <Button
                        type="button"
                        disabled={!isRowValidForAdd(material, schema?.materials?.itemForm?.fields)}
                        onClick={() => {
                          const newIndex = (formData.materials || []).length;
                          const pickedLabel = materialDisplay['new'] || '';
                          const nextMaterials = [...(formData.materials || []), material];
                          setFormData({...formData, materials: nextMaterials});
                          setNewFormData({...newFormData, materials: nextMaterials});
                          setMaterialDisplay(prev => {
                            const copy = {...prev};
                            if (pickedLabel) copy[newIndex] = pickedLabel;
                            copy['new'] = '';
                            return copy;
                          });
                          setMaterial({});
                        }}
                        icon={"pi pi-plus"}
                        className="p-button-success"
                      />
                    </td>
                  </tr>
                  </tfoot>
                  </table>
                </div>
              </>
            }
            <div className={"p-grid p-mt-1"}>
              <div className={"p-col-12 p-lg-6 p-xl-6"}>

              </div>
              <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
                {entity === 'projectItem' &&
                  <Button type="submit" label={t('save')}
                          loading={loading}
                          icon={"pi pi-save"}
                          className="p-button-success p-ml-2"/>
                }
                <Button type="submit" label={t('saveAndBack')}
                        onClick={() => {
                          props = {...props, goback: true}
                        }}
                        loading={loading}
                        icon={"pi pi-arrow-left"}
                        className="p-button-success p-ml-2"/>
              </div>
            </div>
          </form>
        )}
        />
      }
    </div>
  )
}
export default withTranslation('common')(ProjectitemFormComponent);
